import { PayloadAction } from '@reduxjs/toolkit';
import {
  BattlePromotedModel,
  BundleModel,
  FeedModelRow,
  FeedNotificationModel,
} from '$store/models';

type Sections = 'following' | 'explore' | 'smart' | 'liked' | 'sponsored' | '';

interface Feed {
  isLoading: boolean;
  isLoadingMore: boolean;
  items: FeedItem[];
  nextFrom: string;
  sources: { [index: number]: string };
  page: number;
  scrollOffset: number;
}

export enum FeedItemType {
  POST = 'post',
  RECOMMENDATION = 'recommendation',
  ADS = 'ads',
  MODEL = 'model',
  ONLINE_MODEL = 'online_model',
  AD_PROMO_POST = 'ad_promo_post',
  AD_PROMO_PROFILE = 'ad_promo_profile',
  BUNDLE = 'bundle',
  FEATURED_PROFILE = 'featured_profile',
}

export interface FeedItem {
  id: number;
  isSuggestion: boolean;
  object: number | number[] | string | FeedModelRow | BundleModel;
  type: FeedItemType;
}

export interface FeedState {
  suggestions: number[];
  feed: { [key: string]: Feed };
  notifications: FeedNotificationModel[];
  hasNewFollowingPosts: boolean;
  hasNewSponsorsPosts: boolean;
  common: FeedItem[];
  commonLoadingStatus: 'loading' | 'loaded' | 'failed';
  commonNextFrom: string;
  commonLoadingMoreStatus: 'loading' | 'loaded' | 'failed';
  welcomeHidden: boolean;
  activeSection: Sections | null;
  promotedBattle: BattlePromotedModel | null;
  usersSuggestions: number[];
}

export type SetFeedAction = PayloadAction<{
  nextFrom: string;
  items: FeedItem[];
  suggestions: number[];
  notifications: FeedNotificationModel[];
  hasNewFollowingPosts: boolean;
  hasNewSponsorsPosts: boolean;
  sources: { [index: number]: string };
  welcomeHidden: boolean;
  section: string;
}>;
export type SetMoreFeedAction = PayloadAction<{
  nextFrom: string;
  items: FeedItem[];
  hasNewFollowingPosts: boolean;
  hasNewSponsorsPosts: boolean;
  sources: { [index: number]: string };
  section: string;
}>;
export type UnshiftFeedAction = PayloadAction<{ item: FeedItem; section: string }>;
export type LoadFeedAction = PayloadAction<{ section: string; query: string }>;
export type HideNotificationAction = PayloadAction<string>;
export type LoadMoreAction = PayloadAction<{ section: string; query: string }>;
export type HidePostsFromUIAction = PayloadAction<number[] | number>;
export type SetCommonFeedAction = PayloadAction<{
  nextFrom: string;
  items: FeedItem[];
}>;
export type SetActiveSectionAction = PayloadAction<Sections>;
export type SetScrollOffsetAction = PayloadAction<{
  section: string;
  scrollOffset: number;
}>;
export type SetPromotedBattleAction = PayloadAction<BattlePromotedModel | null>;
export type SetFeedUsersSuggestionsAction = PayloadAction<number[]>;
